var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgClick = function SvgClick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 17 17",
    fill: "currentColor"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#click_svg__click_svg__clip0_9315_35492)",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.164 8.234h2m4-6v2m-2.8 1.201L3.897 3.97m7.067 1.465L12.43 3.97m-7.066 7.065l-1.467 1.467m4.267-4.268l6 2-2.667 1.334-1.333 2.666-2-6z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "click_svg__click_svg__clip0_9315_35492"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(.164 .234)",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgClick;